import React from "react";

import { ConfiguratorTypes } from "../../../constants";
import { IImageURL } from "../../../models/nominals";
import { BreakPoint } from "../../../models/screen.interfaces";
import { getViewportBreakpoint } from "../../../utils/detectMobile";
import { FreeDeliveryButtonTypes } from "../constants";
import { IModularConfiguratorShippingMessage } from "../models.interfaces";
import { ConfiguratorFreeDelivery } from "./ConfiguratorFreeDelivery";

import styles from "./ConfiguratorShippingCallout.module.scss";

interface IOwnProps {
    content: string;
    configuratorType: ConfiguratorTypes;
    shippingMessages?: IModularConfiguratorShippingMessage | null;
    phoneNumber?: string;
    iconURL?: IImageURL | null | undefined;
}

export const ConfiguratorShippingCallout = (
    props: IOwnProps,
): React.ReactNode => {
    const buildDescription = () => {
        let content = props.content;
        if (getViewportBreakpoint() > BreakPoint.SMALL) {
            content = content.replace("<br>", "");
        }
        return (
            <div className={styles.content}>
                {props.iconURL && (
                    <img src={`${props.iconURL}`} aria-hidden="true" alt="" />
                )}
                <span>
                    {content}
                    {!!props.shippingMessages && (
                        <ConfiguratorFreeDelivery
                            freeDeliveryButtonTypes={
                                FreeDeliveryButtonTypes.ICON
                            }
                            configuratorType={props.configuratorType}
                            phoneNumber={props.phoneNumber}
                            shippingMessages={props.shippingMessages}
                        />
                    )}
                </span>
            </div>
        );
    };

    return (
        <>
            <div className={styles.container}>{buildDescription()}</div>
        </>
    );
};
